import Firebase from 'firebase'

let config = {
  apiKey: 'AIzaSyA0XCdbV470szQThNdKNY8Ff98_1kQWrOA',
  authDomain: 'exampleradio-aaf5e.firebaseapp.com',
  databaseURL: 'https://exampleradio-aaf5e.firebaseio.com',
  projectId: 'exampleradio-aaf5e',
  storageBucket: 'exampleradio-aaf5e.appspot.com',
  messagingSenderId: '737545143439',
  appId: '1:737545143439:web:07494e6afb980c20645cfa',
  measurementId: 'G-1F6RQZMSVX'
}
let app = Firebase.initializeApp(config)
let db = app.database()
let auth = app.auth()
let storageRef = app.storage().ref()
export { db, storageRef, auth }
